import ChannelInterface from "@/interfaces/channel.interface";

export interface TemplateInterface {
    id?: number;
    title: string;
    content: string;
    originalContent?: string;
    components: TemplateComponentsInterface;
    channels: ChannelInterface[];
    mediaType?: string;
    assetId?: number;
    assetIsLocked?: number;
    createdAt?: string;
    wabaId?: string;
    status?: TemplateStatus;
    category?: TemplateCategory;
    rejectionReason?: { reason: string };
    language?: string;
    submittedAt?: string;
}

export enum TemplateStatus {
    APPROVED = "approved",
    REJECTED = "rejected",
    PENDING = "pending",
    PAUSED = "paused",
    DRAFT = "draft",
}

export enum ComponentHeaderType {
    NONE = "NONE",
    TEXT = "TEXT",
    IMAGE = "IMAGE",
    DOCUMENT = "DOCUMENT",
    VIDEO = "VIDEO",
}

export enum TemplateCategory {
    MARKETING = "marketing",
    UTILITY = "utility",
    AUTHENTICATION = "authentication",
}

export enum ButtonType {
    REPLY = "QUICK_REPLY",
    URL = "URL",
    PHONE = "PHONE_NUMBER",
}

export enum ButtonCategory {
    CALL_TO_ACTION = "CALL-TO-ACTION",
    REPLY = "QUICK-REPLY",
}

export type TemplateComponentsInterface = {
    examples?: string[];
    mediaExamples?: string[];
    header?: {
        type: "HEADER" | "TEXT";
        text: string;
    };
    footer?: {
        type: "FOOTER";
        text: string;
    };
    buttons?: {
        type: "BUTTONS";
        buttons: TemplateComponentButton[];
    };
};

export type TemplateComponentButton =
    | TemplateComponentReplyButtonsInterface
    | TemplateComponentUrlButtonsInterface
    | TemplateComponentPhoneButtonsInterface;

export interface TemplateComponentReplyButtonsInterface {
    type: ButtonType.REPLY;
    text: string;
}

export interface TemplateComponentUrlButtonsInterface {
    type: ButtonType.URL;
    url: string;
    dynamic: boolean;
    text: string;
    examples?: string[];
}

export interface TemplateComponentPhoneButtonsInterface {
    type: ButtonType.PHONE;
    phone_number: string;
    text: string;
}
